import { IconTextGroupListCombinedProps } from './types';

const usePresenter = (props: IconTextGroupListCombinedProps): IconTextGroupListCombinedProps => {
  return props;
};

export default usePresenter;
